export default __webpack_public_path__ + "static/assets/icon_cellwhisperer-3a489201b2f2dfab22680fe7d4fd8bcd.png";